export const adminUsersApiURL = {
  getUsersFromCompanies: "/admin/users",
  addUser: "/admin/users/add",
  updateUser: "/admin/users/update",
  activateDeactivateUser: "admin/users/status",
  resetPassword: "admin/users/reset-password",
  updatePermission: "admin/users/update-permission",

  tasks: "/admin/users-task",
};
